import { StyleSheet, View } from 'react-native';

import { InlineAlert, Text, tokens } from '@fhs/ui';
import { CHECKOUT_ORDER_SUMMARY_HEADING } from '@fhs-legacy/frontend/src/utils/test-ids';

import { useCartStore } from '../../../state/cart-store';

import DeliveryFees from './delivery-fees';
import { TipRow } from './delivery-tips/tips-row';
import DiscountRow from './discount-row';
import DonationRow from './donation-row';
import EstimatedPointsRow from './estimated-points-row';
import SubtotalRow from './subtotal-row';
import TaxRow from './tax-row';
import TotalRow from './total-row';

export function CheckoutOrderSummary() {
  const { cartEntries } = useCartStore();
  const cartIsEmpty = cartEntries.length < 1;

  if (cartIsEmpty) {
    return (
      <InlineAlert
        type="error"
        message="Your cart is empty, add some items to the cart and come back to checkout."
      />
    );
  }
  return (
    <>
      <Text.Heading type="four" style={styles.heading} testID={CHECKOUT_ORDER_SUMMARY_HEADING}>
        Order Summary
      </Text.Heading>
      <SubtotalRow />
      <DonationRow />
      <DiscountRow />
      <TaxRow />
      <DeliveryFees />
      <TipRow />
      <View style={styles.separator} />
      <TotalRow />
      <EstimatedPointsRow />
    </>
  );
}
const styles = StyleSheet.create({
  heading: {
    marginTop: 20,
    marginBottom: 12,
    marginHorizontal: 28,
  },
  separator: {
    height: 1,
    backgroundColor: tokens.colors.$blackOpacity10,
    marginHorizontal: 28,
    marginVertical: 16,
  },
});
